const Notification01Icon = ({ color, height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color ? color : 'currentColor'} fill="none">
			<path
				d="M21.0127 14.4502L19.75 13.1875V9.5C19.75 5.21979 16.2802 1.75 12 1.75C7.71979 1.75 4.25 5.21979 4.25 9.5V13.1875L2.9873 14.4502C2.51512 14.9225 2.25 15.5635 2.25 16.2314C2.25017 17.6223 3.37767 18.7498 4.76855 18.75H19.2314C20.6223 18.7498 21.7498 17.6223 21.75 16.2314C21.75 15.5635 21.4849 14.9225 21.0127 14.4502Z"
				fill={color ? color : 'currentColor'}
			/>
			<path
				d="M15.75 20C15.0345 21.3387 13.624 22.25 12 22.25C10.376 22.25 8.96548 21.3387 8.25 20H15.75Z"
				fill={color ? color : 'currentColor'}
			/>
		</svg>
	);
};

export default Notification01Icon;
